var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.blockArr),function(item,index){return _c('div',{key:index,staticClass:"item",style:('background: ' + item.color)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }